<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pj_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div
            class="weui-form-preview__item"
            slot="pj_decode">
            <label class="weui-form-preview__label">{{
              customLabel.pj_decode || "需求单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_decode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_dename">
            <label class="weui-form-preview__label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_dename
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="de_custname">
            <label class="weui-form-preview__label">{{
              customLabel.de_custname || "项目来源"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_custname
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_product_type">
            <label class="weui-form-preview__label">{{
              customLabel.pj_product_type || "产品类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_product_type
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="de_emname">
            <label class="weui-form-preview__label">{{
              customLabel.de_emname || "需求人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_emname
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="de_dpname">
            <label class="weui-form-preview__label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_dpname
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_project_classify">
            <label class="weui-form-preview__label">{{
              customLabel.pj_project_classify || "项目分类"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_project_classify
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_project_level">
            <label class="weui-form-preview__label">{{
              customLabel.pj_project_level || "项目等级"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_project_level
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_emname">
            <label class="weui-form-preview__label">{{
              customLabel.pj_emname || "项目负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_begin_date">
            <label class="weui-form-preview__label">{{
              customLabel.pj_begin_date || "计划开始时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pj_begin_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_end_date">
            <label class="weui-form-preview__label">{{
              customLabel.pj_end_date || "计划结束时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pj_end_date
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_budget">
            <label class="weui-form-preview__label">{{
              customLabel.pj_budget || "项目预算金额"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_budget
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_marcode">
            <label class="weui-form-preview__label">{{
              customLabel.pj_marcode || "市场分析报告单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_marcode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_tarcode">
            <label class="weui-form-preview__label">{{
              customLabel.pj_tarcode || "技术可行性分析报告单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_tarcode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pj_carcode">
            <label class="weui-form-preview__label">{{
              customLabel.pj_carcode || "成本分析报告单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_carcode
            }}</span>
          </div>
        </custom-layout>
      </div>
      <div class="tab">
        <a :class="{ active: activity == 1 }" @click="setActivity(1)"
          >配置需求明细</a
        >
        <a :class="{ active: activity == 2 }" @click="setActivity(2)"
          >主要参数</a
        >
      </div>
      <collapse
        class="form-preview weui-form-preview"
        :title="'配置需求明细（' + form.items1?.length + '条）'"
        v-show="activity == 1"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.dd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="dd_name">
              <label class="weui-form-preview__label">{{
                customLabel.dd_name || "名称"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_name }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_spec">
              <label class="weui-form-preview__label">{{
                customLabel.dd_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_spec }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_brand">
              <label class="weui-form-preview__label">{{
                customLabel.dd_brand || "品牌"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_brand }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_colour">
              <label class="weui-form-preview__label">{{
                customLabel.dd_colour || "颜色"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_colour }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_size">
              <label class="weui-form-preview__label">{{
                customLabel.dd_size || "尺寸"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_size }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_texture">
              <label class="weui-form-preview__label">{{
                customLabel.dd_texture || "材质"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_texture
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_silkscreen">
              <label class="weui-form-preview__label">{{
                customLabel.dd_silkscreen || "丝印"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_silkscreen
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_standard">
              <label class="weui-form-preview__label">{{
                customLabel.dd_standard || "标准"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_standard
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_remark">
              <label class="weui-form-preview__label">{{
                customLabel.dd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_remark }}</span>
            </div>
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text1 || '自定义字段1'"
              v-model="form.main.dd_text1"
              slot="dd_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text2 || '自定义字段2'"
              v-model="form.main.dd_text2"
              slot="dd_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text3 || '自定义字段3'"
              v-model="form.main.dd_text3"
              slot="dd_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text4 || '自定义字段4'"
              v-model="form.main.dd_text4"
              slot="dd_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text5 || '自定义字段5'"
              v-model="form.main.dd_text5"
              slot="dd_text5"
              hidden="true"
            />
          </custom-layout>
        </div>
      </collapse>
      <collapse
        class="form-preview weui-form-preview"
        :title="'主要参数（' + form.items2?.length + '条）'"
        v-show="activity == 2"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="main in form.items2"
          :key="main.id"
        >
          <div class="form-detail-preview_num">{{ main.pp_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail2">
            <div class="weui-form-preview__item" slot="pp_name">
              <label class="weui-form-preview__label">{{
                customLabel.pp_name || "参数名称"
              }}</label>
              <span class="weui-form-preview__value">{{ main.pp_name }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pp_value">
              <label class="weui-form-preview__label">{{
                customLabel.pp_value || "参数值"
              }}</label>
              <span class="weui-form-preview__value">{{ main.pp_value }}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>
      <collapse
        class="form-preview weui-form-preview"
        :title="'研发阶段（' + form.items3?.length + '条）'"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="main in form.items3"
          :key="main.id"
        >
          <div class="form-detail-preview_num">{{ main.pp_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail3">
            <div class="weui-form-preview__item" slot="pp_name">
              <label class="weui-form-preview__label">{{
                customLabel.pp_name || "研发阶段"
              }}</label>
              <span class="weui-form-preview__value">{{ main.pp_name }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pp_emname">
              <label class="weui-form-preview__label">{{
                customLabel.pp_emname || "阶段负责人"
              }}</label>
              <span class="weui-form-preview__value">{{ main.pp_emname }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pp_tel">
              <label class="weui-form-preview__label">{{
                customLabel.pp_tel || "联系电话"
              }}</label>
              <span class="weui-form-preview__value">{{ main.pp_tel }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pp_begin_date">
              <label class="weui-form-preview__label">{{
                customLabel.pp_begin_date || "开始日期"
              }}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
                main.pp_begin_date
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pp_end_date">
              <label class="weui-form-preview__label">{{
                customLabel.pp_end_date || "完成日期"
              }}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
                main.pp_end_date
              }}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>
      <collapse
        class="form-preview weui-form-preview"
        :title="'任务安排明细（' + form.items4?.length + '条）'"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="main in form.items4"
          :key="main.id"
        >
          <div class="form-detail-preview_num">{{ main.ta_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail4">
            <div class="weui-form-preview__item" slot="ta_task">
              <label class="weui-form-preview__label">{{
                customLabel.ta_task || "任务节点名称"
              }}</label>
              <span class="weui-form-preview__value">{{ main.ta_task }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_rpname">
              <label class="weui-form-preview__label">{{
                customLabel.ta_rpname || "研发阶段"
              }}</label>
              <span class="weui-form-preview__value">{{ main.ta_rpname }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_role">
              <label class="weui-form-preview__label">{{
                customLabel.ta_role || "岗位"
              }}</label>
              <span class="weui-form-preview__value">{{ main.ta_role }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_emname">
              <label class="weui-form-preview__label">{{
                customLabel.ta_emname || "任务责任人"
              }}</label>
              <span class="weui-form-preview__value">{{ main.ta_emname }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_emtel">
              <label class="weui-form-preview__label">{{
                customLabel.ta_emtel || "联系电话"
              }}</label>
              <span class="weui-form-preview__value">{{ main.ta_emtel }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_planworkhour">
              <label class="weui-form-preview__label">{{
                customLabel.ta_planworkhour || "计划工时"
              }}</label>
              <span class="weui-form-preview__value">{{
                main.ta_planworkhour
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_planbegindate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_planbegindate || "开始日期"
              }}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd hh:mm:ss'"
                >{{ main.ta_planbegindate }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="ta_planenddate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_planenddate || "完成日期"
              }}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd hh:mm:ss'"
                >{{ main.ta_planenddate }}</span
              >
            </div>
          </custom-layout>
        </div>
      </collapse>
      <file-list v-model="form.main.pj_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/plm/proj_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import Collapse from "@/components/Collapse.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    Collapse,
    CustomField,
  },
  data() {
    return {
      activity: 1,
      baseUrl: "/api/plm/proj",
      codeField: "pj_code",
      statusField: "pj_statuscode",
      caller: "PlmProj",
      xtype: "plm-proj-formpanel",
      form: {
        main: {
          pj_decode: null,
          pj_dename:null
        },
        items1: [],
        items2: [],
        items3: [],
        items4: [],
      },
    };
  },
  methods: {
    setActivity: function (activity) {
      this.activity = activity;
    },
  },
};
</script>
<style scoped>
.tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: #fff;
}
.tab > a {
  padding: 10px 20px;
}
.tab > .active {
  color: #1c8ef0;
}
</style>